export const otherCeremonyTypeCode = '18';
